export const setSettings = function(state, payload) {
  state.settings = payload;
};
